<div class="modal-header">
    <div class="title">
        <h2 class="modal-title">Supprimer mon compte <i class="fa fa-exclamation-triangle fa-lg" aria-hidden="true"></i>
        </h2>
    </div>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body d-flex flex-column ">
    <h6 class="warning-text">Voulez-vous vraiment supprimer votre compte, vous donnant accès aux applications de
        menuiserie? Attention la
        suppression du compte entraine la perte de l'ensemble de vos données sauvegardées.</h6>
    <div class="mdp">
        <!-- Phone -->
        <label for="password" class="form-label required">Mot de passe</label>
        <input type="password" class="form-control" id="password" [(ngModel)]="infos.pass" required>
    </div>
    <div class="col-sm-12 d-flex flex-column modify-block">
        <button class="deletion" (click)="deleteAccount()">
            Supprimer mon compte
        </button>
        <button class="cancel" (click)="activeModal.dismiss('Cross click')">
            Annuler
        </button>
    </div>
</div>